module.exports = __webpack_public_path__ + "img/vair.7779f849.svg";